import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';


export namespace DoppeActionTypeCalendly {

    export interface ActionSettings {
        calenderUrl: string;
        showCookieBanner: boolean;
        showPageDetails: boolean;
        showEventDetails: boolean;
    }


}

export const doppeActionTypeCalendly = doppeActionTypeDefineMetadata<DoppeActionTypeCalendly.ActionSettings>({
    id: 'io.bymo.action/calendly',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        calenderUrl: '',
        showCookieBanner: false,
        showPageDetails: true,
        showEventDetails: true,
    }),
    hasNoGoalMeasuring: false,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            calenderUrl: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isModalOpener: true,
    canRenderInPage: false,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    hasNoLockInnerCTA: true,
})

